
import React, { Component } from 'react';
import '../css/style.css';
import {Container,Row, Col} from 'react-bootstrap';
import { translate } from "react-i18next";
import i18n from "i18next";


class Agb extends Component {

    render(){
      let lang = i18n.language;
      if(!lang){
        lang ='de'
      }
      if('de' === lang){
        return (
          <Container fluid className="fluid">
          <Row >
            <Col >
            <h1 class="mb-4 mt-4">{lang}Lerne uns kennen!</h1>
                  <p>Überall dieselbe alte Leier. Das Layout ist fertig, der Text lässt auf sich warten. Damit das Layout nun nicht nackt im Raume steht und sich klein und leer vorkommt, springe ich ein: der Blindtext.</p>
                  <p>Genau zu diesem Zwecke erschaffen, immer im Schatten meines großen Bruders »Lorem Ipsum«, freue ich mich jedes Mal, wenn Sie ein paar Zeilen lesen. Denn esse est percipi - Sein ist wahrgenommen werden.</p>
                  <p>Und weil Sie nun schon die Güte haben, mich ein paar weitere Sätze lang zu begleiten, möchte ich diese Gelegenheit nutzen, Ihnen nicht nur als Lückenfüller zu dienen, sondern auf etwas hinzuweisen, das es ebenso verdient wahrgenommen zu werden: Webstandards nämamalich. Sehen Sie, Webstandards sind das Regelwerk, auf dem Webseiten aufbauen.</p>
                  <p>So gibt es Regeln für HTML, CSS, JavaScript oder auch XML; Worte, die Sie vielleicht schon einmal von Ihrem Entwickler gehört haben. Diese Standards sorgen dafür, dass alle Beteiligten aus einer Webseite den größten Nutzen ziehen.</p>
                  <p class="text-uppercase text-muted mt-4">&mdash; Mug &amp; move Team</p>
  
            
            </Col>
          </Row>
      </Container>
         );
      }
      // end de
      if('en' === lang){
        return (
          <Container fluid className="fluid">
          <Row >
            <Col >
            <h1 class="mb-4 mt-4">{lang}EN Lerne uns kennen!</h1>
                  <p>Überall dieselbe alte Leier. Das Layout ist fertig, der Text lässt auf sich warten. Damit das Layout nun nicht nackt im Raume steht und sich klein und leer vorkommt, springe ich ein: der Blindtext.</p>
                  <p>Genau zu diesem Zwecke erschaffen, immer im Schatten meines großen Bruders »Lorem Ipsum«, freue ich mich jedes Mal, wenn Sie ein paar Zeilen lesen. Denn esse est percipi - Sein ist wahrgenommen werden.</p>
                  <p>Und weil Sie nun schon die Güte haben, mich ein paar weitere Sätze lang zu begleiten, möchte ich diese Gelegenheit nutzen, Ihnen nicht nur als Lückenfüller zu dienen, sondern auf etwas hinzuweisen, das es ebenso verdient wahrgenommen zu werden: Webstandards nämamalich. Sehen Sie, Webstandards sind das Regelwerk, auf dem Webseiten aufbauen.</p>
                  <p>So gibt es Regeln für HTML, CSS, JavaScript oder auch XML; Worte, die Sie vielleicht schon einmal von Ihrem Entwickler gehört haben. Diese Standards sorgen dafür, dass alle Beteiligten aus einer Webseite den größten Nutzen ziehen.</p>
                  <p class="text-uppercase text-muted mt-4">&mdash; Mug &amp; move Team</p>
  
            
            </Col>
          </Row>
      </Container>
         );
      }
      // end en
      if('fr' === lang){
        return (
          <Container fluid className="fluid">
          <Row >
            <Col >
            <h4 class="mb-4 mt-4">{lang}FR Lerne uns kennen!</h4>
                  <p>Überall dieselbe alte Leier. Das Layout ist fertig, der Text lässt auf sich warten. Damit das Layout nun nicht nackt im Raume steht und sich klein und leer vorkommt, springe ich ein: der Blindtext.</p>
                  <p>Genau zu diesem Zwecke erschaffen, immer im Schatten meines großen Bruders »Lorem Ipsum«, freue ich mich jedes Mal, wenn Sie ein paar Zeilen lesen. Denn esse est percipi - Sein ist wahrgenommen werden.</p>
                  <p>Und weil Sie nun schon die Güte haben, mich ein paar weitere Sätze lang zu begleiten, möchte ich diese Gelegenheit nutzen, Ihnen nicht nur als Lückenfüller zu dienen, sondern auf etwas hinzuweisen, das es ebenso verdient wahrgenommen zu werden: Webstandards nämamalich. Sehen Sie, Webstandards sind das Regelwerk, auf dem Webseiten aufbauen.</p>
                  <p>So gibt es Regeln für HTML, CSS, JavaScript oder auch XML; Worte, die Sie vielleicht schon einmal von Ihrem Entwickler gehört haben. Diese Standards sorgen dafür, dass alle Beteiligten aus einer Webseite den größten Nutzen ziehen.</p>
                  <p class="text-uppercase text-muted mt-4">&mdash; Mug &amp; move Team</p>
  
            
            </Col>
          </Row>
      </Container>
         );
      }
    }
}

export default translate("translations")(Agb);